var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E5F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_14154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 31.6667C30 29.2773 31.9441 27.3333 34.3333 27.3333H38.6667V23.6667C38.6667 21.644 37.0227 20 35 20H19.6667C17.644 20 16 21.644 16 23.6667V40.3333C16 42.356 17.644 44 19.6667 44H30V31.6667Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6667 29.334H34.3333C33.0454 29.334 32 30.3794 32 31.6675V45.6675C32 46.9553 33.0454 48.0007 34.3333 48.0007H45.6667C46.9546 48.0007 48 46.9553 48 45.6675V31.6675C48 30.3794 46.9546 29.334 45.6667 29.334Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.833 41.334H36.833C36.281 41.334 35.833 40.886 35.833 40.334C35.833 39.782 36.281 39.334 36.833 39.334H42.833C43.385 39.334 43.833 39.782 43.833 40.334C43.833 40.886 43.385 41.334 42.833 41.334Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.833 37.334H36.833C36.281 37.334 35.833 36.886 35.833 36.334C35.833 35.782 36.281 35.334 36.833 35.334H42.833C43.385 35.334 43.833 35.782 43.833 36.334C43.833 36.886 43.385 37.334 42.833 37.334Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.333 18.6667H30.8611C30.425 17.1294 29.0078 16 27.333 16C25.6584 16 24.2412 17.1294 23.8052 18.6667H22.333C21.781 18.6667 21.333 19.1147 21.333 19.6667V22.3333C21.333 23.6201 22.3796 24.6667 23.6665 24.6667H30.9998C32.2864 24.6667 33.333 23.6201 33.333 22.3333V19.6667C33.333 19.1147 32.885 18.6667 32.333 18.6667Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_14154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyTasks);
export default __webpack_public_path__ + "static/media/daily-tasks.87dbf1f6c946763e54a0291cf0cd346e.svg";
export { ForwardRef as ReactComponent };